import { atomFamily } from "recoil";

import { type MyLensesLensStatus } from "../../gql-generated/types";
import { type PaginationAtomsKeys } from "../../shared/state";

export const filterIsEmptyAtom = atomFamily<boolean, PaginationAtomsKeys>({
    key: "filterIsEmptyAtom",
    default: false,
});

export const filterByStatusAtom = atomFamily<MyLensesLensStatus[], PaginationAtomsKeys>({
    key: "filterByStatusAtom",
    default: [],
});

export const searchInputAtom = atomFamily<string, PaginationAtomsKeys>({
    key: "searchInputAtom",
    default: "",
});
